import type { ClinicalEvent } from './types';
export function eventHeads(events: ClinicalEvent[]) {
  const heads = new Map<string, ClinicalEvent>();
  for (const event of events) {
    const current = heads.get(event.root_id);
    if (!current || event.sequence > current.sequence) heads.set(event.root_id, event);
  }
  return [...heads.values()].sort((a, b) => a.occurred_at.localeCompare(b.occurred_at) || a.sequence - b.sequence);
}
export function activeEvents(events: ClinicalEvent[]) {
  return eventHeads(events).filter((e) => e.status === 'ACTIVE');
}
export function displayPayload(payload: Record<string, unknown>) {
  return Object.entries(payload)
    .map(([key, value]) => `${key.replaceAll('_', ' ')}: ${Array.isArray(value) ? value.join(', ') : String(value)}`)
    .join(' · ');
}
